import { Component } from '@angular/core';
import { LayoutModule } from '../../../layout/layout.module';
import { UsersModule } from '../../../../users/users.module';

@Component({
  selector: 'app-users-dashboard-page',
  standalone: true,
  imports: [
    LayoutModule,
    UsersModule,
  ],
  templateUrl: './users-dashboard-page.component.html',
})
export class UsersDashboardPageComponent { }
